import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=d5fd50a6&scoped=true&"
import script from "./EditCompany.vue?vue&type=script&lang=js&"
export * from "./EditCompany.vue?vue&type=script&lang=js&"
import style0 from "./EditCompany.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditCompany.vue?vue&type=style&index=1&id=d5fd50a6&lang=scss&scoped=true&"
import style2 from "./EditCompany.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./EditCompany.vue?vue&type=style&index=3&id=d5fd50a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fd50a6",
  null
  
)

component.options.__file = "EditCompany.vue"
export default component.exports